import { chakra } from '@stockx/ui';

export const MobileSearchBar = chakra('div', {
  baseStyle: {
    display: { base: 'block', md: 'none' },
  },
});

export const MobileSearch = chakra('div', {
  baseStyle: {
    display: { base: 'block', md: 'none' },
    width: '50px',
    textAlign: 'center',
    fontSize: 'lg',
  },
});
